export default __webpack_public_path__ + "static/media/img_03.32318c15.jpg";